var React = require('react');

function IconSearch (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1.25 .862)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5"},[React.createElement("circle",{"cx":"9.5","cy":"9.5","r":"9.5","transform":"translate(-.5 -.112)","key":0}),React.createElement("path",{"transform":"translate(16.377 15.428)","d":"M7.752 7.752L0 0","key":1})]));
}

IconSearch.defaultProps = {"className":"icon-search","viewBox":"0 0 26.44 25.103","width":"26.44","height":"25.103","preserveAspectRatio":"xMidYMid meet"};

module.exports = IconSearch;

IconSearch.default = IconSearch;
